<div [style.top]="selectedTopPick() ? '280px' : '200px'" class="report-analyzer-container">
  <div class="icon"><img [src]="quinnyAiAvatarUrl" width="40" height="40" alt="" /></div>
  <div (click)="onClose()" class="close">
    <i nz-icon nzType="close"></i>
  </div>
  <div class="description">QUINNY AI REPORT ANALYZER</div>
  @if (selectedTopPick()) {
  <div class="info">
    <p>✨ Before <span class="bold">Quinny AI</span> can analyze your report, set the report filters and click
      <strong>Preview</strong>
      to generate the results.</p>
  </div>
  <div class="top-picks">
    <p>Once the preview is ready, click <strong>Quinny AI</strong> icon in the side panel to get intelligent insight
      instantly!</p>
    <div (click)="qbotWidgetSrv.selectedTopPick.set(null)" class="browse">⬅️ Back to the Top Picks</div>
  </div>

  } @else {
  <div class="info">
    <p>
      Let <span class="bold">Quinny AI</span> do the thinking for you!
    </p>
    <p>Generate any report and tap the AI Analyzer to unlock powerful, data-driven insights. </p>

    <p>Instantly identify key-trends, spot anomalies, and receive intelligent summaries - all designed to help you
      make quicker, smarter business decisions with confidence! </p>
  </div>

  <!-- Re-enable to block Quinny AI for sample / free-trial companies:
  @if (isSampleOrTrial()) {
  <div class="top-picks">
    <div (click)="onUpgrade()" style="text-align: center">✨ <span class="browse pick"> Upgrade Now to Unlock
        Feature</span></div>
  </div>
  } @else {
  -->
  <div class="top-picks">
    <strong>✨ Top Picks: Insights from User Activity</strong>
    @for (t of mappedTopPicks(); track t.name) {
    <div [class.small-font]="smallFont()" [class.pick]="canView(t.acl)" [class.pick-disabled]="!canView(t.acl)"
        (click)="canView(t.acl) && onReportClicked(t?.path)">
      @if (!canView(t.acl)) {
        <span nz-tooltip nzTooltipTitle="You do not have permission" nzTooltipPlacement="left"
            [nzTooltipOverlayStyle]="{ 'margin-right': '10px' }">{{ t?.name }}</span>
      } @else {
        {{ t?.name }}
      }
    </div>
    }
    <div (click)="showBrowseModal()" class="browse">📁 Browse Other Reports</div>
  </div>
  <!-- } -->
  }
</div>

<nz-modal [nzVisible]="showBrowseReports()" [nzFooter]="customFooter" nzTitle="Browse Report"
  [nzBodyStyle]="{ 'min-height': '300px' }" (nzOnCancel)="showBrowseReports.set(false)" [nzAutofocus]="null">
  <ng-container *nzModalContent>
    <form nz-form nzLayout="horizontal" se-container="1">
      <se [hideLabel]="true">
        <label>Report Title</label>
        <input [formControl]="searchTermCtrl" style="width: 100%" nz-input app-auto-focus name="searchTerm" />
      </se>
    </form>

    @if (searchResults().length > 0 && !loading()) {
    <div class="search-result">
      <div>({{ searchResults().length }}) Results Found:</div>
      @for (r of searchResults(); track r) {
      <div style="text-decoration: underline;margin-left: 20px;cursor: pointer;margin-top: 5px"
        (click)="onReportClicked(r?.path)">{{ r?.name }}
      </div>
      }
    </div>
    }
    @if(loading()){
    <div class="loading-container">
      <nz-spin nzSimple></nz-spin>
    </div>
    }
  </ng-container>

  <ng-template #customFooter>
    <!-- Empty template hides all buttons -->
  </ng-template>
</nz-modal>